import axios from 'axios';
import { IBillingPayload } from '@/settings/billing/store/billing.constants';

export default class BillingService {
  static update = async (payload: IBillingPayload, entityId: string): Promise<void> => {
    const data = new FormData();
    data.append('action', 'entity');
    data.append('id', entityId);
    data.append('field', payload.field);
    data.append('value', payload.value);
    const {
      data: { error },
    } = await axios.post('/save/settings', data);
    if (error) {
      throw new Error(error);
    }
  };

  static validate = async (): Promise<string> => {
    const {
      data: { error },
    } = await axios.get('/get/settings/plan-settings');
    return error;
  };
}
